import { BaseLayout } from "./BaseLayout";

export class FullscreenContentLayout extends BaseLayout {
    private static layout = require("./Templates/Fullscreen.html").default;

    apply(): void {
        $("body").addClass("dms-fullscreen");
        this.setContentLayout(FullscreenContentLayout.layout);
    }

    dispose(): void {
        $("body").removeClass("dms-fullscreen");
        super.dispose();
    }
}
